module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "statistics"
  }, [_c('h3', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaigns_24hPerformance")))]), _vm._v(" "), _c('div', {
    staticClass: "statistics__zone"
  }, [_c('line-chart', {
    staticClass: "statistics__chart--fullWidth",
    attrs: {
      "chartData": _vm.performanceData,
      "options": _vm.performanceOptions
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaigns_TopLinks")))]), _vm._v(" "), _c('div', {
    staticClass: "statistics__zone"
  }, [_c('ul', {
    staticClass: "statistics__list"
  }, _vm._l((_vm.links), function(link) {
    return _c('li', {
      key: link.url,
      staticClass: "statistics__entry"
    }, [_c('a', {
      staticClass: "link",
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.text || link.url))]), _vm._v(" "), _c('span', {
      staticClass: "statistics__list__value"
    }, [_vm._v(_vm._s(link.clicksCount))])])
  }), 0)]), _vm._v(" "), _c('h3', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaigns_Performance")))]), _vm._v(" "), _c('div', {
    staticClass: "statistics__zone"
  }, [_c('ProgressBar', {
    attrs: {
      "label": "Campaigns_OpenRate",
      "max": _vm.report.sentCount,
      "percent": _vm.report.opensCount
    }
  }), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "label": "Campaigns_DeliveryRate",
      "max": _vm.report.sentCount,
      "percent": _vm.report.deliveriesCount,
      "doNotExceedMax": true
    }
  }), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "label": "Campaigns_ClickOpen",
      "max": _vm.report.opensCount,
      "percent": _vm.report.clicksCount
    }
  }), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "label": "Campaigns_UnsubscribeRate",
      "max": _vm.report.sentCount,
      "percent": _vm.report.unsubscribeCount
    }
  }), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "label": "Campaigns_BounceRate",
      "max": _vm.report.sentCount,
      "percent": _vm.report.bouncesCount
    }
  }), _vm._v(" "), _c('ProgressBar', {
    attrs: {
      "label": "Campaigns_ComplaintRate",
      "max": _vm.report.sentCount,
      "percent": _vm.report.complaintsCount
    }
  })], 1), _vm._v(" "), _c('h3', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaigns_Preview")))]), _vm._v(" "), _c('article', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "preview__content",
    domProps: {
      "innerHTML": _vm._s(_vm.campaign.body)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3c17e517!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignSuccess.vue
// module id = 727
// module chunks = 1